﻿import FileUpload from '../../../helpers/FileUpload';
import RecieverForm from '../shared/RecieverForm';
import MachineAgrementFormValidation from './MachineAgrementFormValidation';
import MachineAgreementReview from './MachineAgreementReview';
import AgreementRepository from '../../../repositories/AgreementRepository';

/**
 * Machine Agreement form
 */
export default class MachineAgreementForm {
    /**
     * Init
     */
    constructor() {
        // Prevents class being used outside of project scope to avoid errors
        if (document.getElementsByClassName('machine-agreement').length < 1) {
            return;
        }

        // Fetch Reciever data & populate customer drop down
        new MachineAgreementReview();

        // Reciever Data for DropDown
        new RecieverForm('machines');

        // Validation class
        this.validation = new MachineAgrementFormValidation();

        // EventListerners
        this.initEventListerners();

        // Repository
        this.repository = new AgreementRepository('machines');
        this.repository.fetchRecieverDataAsync('/api/e-signing/get-receivers-for-digital-signing');

        // File upload
        this.fileupload = new FileUpload();
        this.fileupload.fileInputOnChange('agreementFile');
    }

    /**
     * @description Submit Machine agreement data
     * @param {*} evt
     * @returns void
     */
    submitMachineAgreementData = () => {
        this.repository.postMachineAgreementDataAsync('/api/e-signing/agreements/machine');
    };

    /**
     * @description  Get data from system
     * @returns void
     */
    initEventListerners() {
        // Validation
        document
            .querySelector('#agreementNumber')
            .addEventListener('focus', this.validation.agreementRegex);
        document.querySelector('#agreementNumber').dispatchEvent(new Event('focus'));

        // Select Agreement Template - set placeholder
        for (let item of document.querySelectorAll('#selectTemplate a')) {
            item.addEventListener(
                'click',
                (evt) => {
                    this.agreementTemplate(evt);
                },
                false
            );
        }

        //Fileupload
        document.querySelector('.btn_fileupload').addEventListener('click', () => {
            document.getElementById('agreementFile').click();
        });

        // Submit data
        document
            .querySelector('#postMachineAgreement')
            .addEventListener('click', this.submitMachineAgreementData);
    }

    /**
     * @description Change Placeholder if agreementtemplate change
     * @param {*} evt
     * @returns void
     */
    agreementTemplate(evt) {
        let template;
        const selectedTemplate = evt.target.getAttribute('data-template');
        const machineAgreementTranslation = window.machineAgreementTranslation;
        
        switch (selectedTemplate) {
            case 'MachinePurchasingAgreement':
                template = {
                    type: '12345AB',
                    regx: /^\d{5}\w{2,}$/,
                    msg: `${machineAgreementTranslation.agreementNumberFormat} 12345AB`,
                    typeName: 'Avtalsnummer',
                };
                break;
            case 'MachineServiceAgreement':
                template = {
                    type: 'ABCDE123XY4567890',
                    regx: /^[A-HJ-NPR-Z0-9]{17}$/,
                    msg: `${machineAgreementTranslation.agreementNumberFormat}  ABCDE123XY4567890`,
                    typeName: 'Vin-nummer',
                };

                break;
            default:
                template = {
                    type: '12345AB',
                    regx: /^\d{5}\w{2,}$/,
                    msg: `${machineAgreementTranslation.agreementNumberFormat} 12345AB`,
                    typeName: 'Avtalsnummer',
                };
        }

        document
            .getElementById('agreementTemplate')
            .setAttribute('data-selectedDataTemplate', template.type);
        document.getElementById('agreementNumber').value = '';
        document.getElementById('agreementNumber').setAttribute('placeholder', template.type);
        document.getElementById(
            'agreementNumberFormat'
        ).innerHTML = `${template.typeName} (${template.type})`;
        document.getElementById('agreementNumber').classList.remove('disabled');
        document.querySelector('.btn_fileupload').classList.remove('disabled');

        this.validation.changeRegexRules(template);
    }
}
